export const SELECTION_LIST_SURFACE_CLASSES =
  "overflow-auto rounded-[12px] border border-black-tint-93 bg-white p-2 text-sm shadow-modal " +
  "supports-squircle:rounded-[24px] supports-squircle:corner-squircle";

export const SELECTION_LIST_OPTION_CLASSES =
  "flex cursor-pointer items-center gap-3 rounded-[8px] px-3 py-2 text-black-tint-20 " +
  "hover:bg-black-tint-93 data-[focus]:bg-black-tint-93 " +
  "data-[selected]:bg-blue-shade-20 data-[selected]:text-white " +
  "data-[selected]:hover:bg-blue data-[selected]:data-[focus]:bg-blue " +
  "supports-squircle:rounded-[16px] supports-squircle:corner-squircle";

export const SELECTION_LIST_OPTION_LABEL_CLASSES = "block min-w-0 truncate";
